import axios from 'axios';

export const fetchEnterpriseConnection = async accountId => {
  const { data } = await axios.get(`enterprise-connections/${accountId}`);

  return data;
};
